import { createPortal } from "react-dom";

import { FloatingImpersonationWindow } from "./components/FloatingImpersonationWindow";
import { ImpersonationBalloon } from "./components/ImpersonationBalloon";
import { useImpersonationSessions } from "./ImpersonationSessionsProvider";

export function ImpersonationSessionsOverlay() {
  const { sessions } = useImpersonationSessions();

  if (sessions.length === 0) {
    return null;
  }

  return createPortal(
    <>
      {sessions.map((session) => (
        <div key={session.id}>
          {session.isActive && <FloatingImpersonationWindow session={session} />}
          {(!session.isActive || session.isMinimized) && <ImpersonationBalloon session={session} />}
        </div>
      ))}
    </>,
    document.body
  );
}
